import type { CustomFlowbiteTheme } from 'flowbite-react';

export const paginationTheme: CustomFlowbiteTheme['pagination'] = {
  base: '',
  layout: {
    table: {
      base: 'text-sm text-titan-night-700',
      span: 'font-semibold text-titan-night-900',
    },
  },
  pages: {
    base: 'xs:mt-0 mt-2 inline-flex items-center -space-x-px',
    showIcon: 'inline-flex',
    previous: {
      base: 'ml-0 rounded-l-lg border border-titan-night-300 bg-white py-2 px-3 leading-tight text-titan-night-500 enabled:hover:bg-titan-night-100 enabled:hover:text-titan-night-700',
      icon: 'h-5 w-5',
    },
    next: {
      base: 'rounded-r-lg border border-titan-night-300 bg-white py-2 px-3 leading-tight text-titan-night-500 enabled:hover:bg-titan-night-100 enabled:hover:text-titan-night-700',
      icon: 'h-5 w-5',
    },
    selector: {
      base: 'w-12 border border-titan-night-300 bg-white py-2 leading-tight text-titan-night-500 enabled:hover:bg-titan-night-100 enabled:hover:text-titan-night-700',
      active:
        'bg-titan-folly-50 text-titan-folly-600 hover:bg-titan-folly-100 hover:text-titan-folly-700',
      disabled: 'opacity-50 cursor-not-allowed',
    },
  },
};
